import React, { useState } from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../../helpers/IntlMessages";
import languageList from "../../../../lang/locales/language_list";
import { templateGetItem, addTempMessage } from "../../../../redux/request/actions";

const AddNewTemplate = ({ setOpenEdit, setDropDownValue, addTempMessage, templateGetItem, open, setOpen }) => {
  const [formLang, setFormLang] = useState("Abkhaz");
  const [formTitle, setFormTitle] = useState();
  const [formText, setFormText] = useState();

  const handleSubmit = async event => {
    const update = {
      language: {}
    };
    update.language[formLang] = [];
    update.language[formLang].push({ title: formTitle, text: formText });
    setOpenEdit(false);
    await addTempMessage(update);
    setDropDownValue(formLang);
    await templateGetItem();
  };
  return (
    <div>
      <ModalBody>
        <FormGroup>
          <Label for="exampleSelect">
            <IntlMessages id="template.chooseLang" />
          </Label>
          <Input id="exampleSelect" name="select" type="select" value={formLang} onChange={e => setFormLang(e.target.value)}>
            {languageList.map(item => (
              <option value={item.name} key={item.code}>
                {item.name}
              </option>
            ))}
          </Input>
          <Label className="mt-2">
            <IntlMessages id="template.title" />
          </Label>
          <Input id="title" onChange={e => setFormTitle(e.target.value)} />
          <Label className="mt-2">
            <IntlMessages id="template.text" />
          </Label>
          <Input id="text" onChange={e => setFormText(e.target.value)} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          color="light"
          onClick={() => {
            setOpen(!open);
            templateGetItem();
          }}
        >
          <IntlMessages id="template.cancel" />
        </Button>
        <Button
          color="primary"
          type="button"
          onClick={e => {
            setOpen(!open);
            handleSubmit();
          }}
        >
          <IntlMessages id="template.save" />
        </Button>
      </ModalFooter>
    </div>
  );
};

const mapStateToProps = ({ requestApp, settings }) => {
  const { templateMessages } = requestApp;
  return { templateMessages };
};
export default injectIntl(
  connect(
    mapStateToProps,
    {
      addTempMessage,
      templateGetItem
    }
  )(AddNewTemplate)
);
